import React, { useState } from "react";
import "../../../Styles/Login.css";
import LoginPopup from "./Loginpopup";
import { FaBoxOpen, FaUser, FaStar, FaQuestionCircle } from "react-icons/fa";

const LoginProfile = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="login-profile-page">
      <div className="left-section">
        <div className="info-card">
          <div className="info-left">
            <FaBoxOpen className="icon" />
            <div className="text-block">
              <h3>My Orders</h3>
              <p style={{ color: "black" }}>
                Track your orders, refunds and download order confirmation
              </p>
            </div>
          </div>
          <button className="btn btn-outline btn-sm" onClick={() => setOpen(true)}>
            Login to track orders
          </button>
        </div>

        <div className="info-card">
          <div className="info-left">
            <FaUser className="icon" />
            <div className="text-block">
              <h3>My Profile</h3>
              <p style={{ color: "black" }}>
                Edit/update your profile details and address
              </p>
            </div>
          </div>
          <button className="btn btn-outline btn-sm" onClick={() => setOpen(true)}>
            Login to view profile
          </button>
        </div>

        <div className="info-card">
          <div className="info-left">
            <FaStar className="icon" />
            <div className="text-block">
              <h3>My Wishlist</h3>
              <p style={{ color: "black" }}>Buy from items saved in wishlist</p>
            </div>
          </div>
          <span className="arrow">›</span>
        </div>

        <div className="info-card">
          <div className="info-left">
            <FaQuestionCircle className="icon" />
            <div className="text-block">
              <h3>FAQs</h3>
              <p style={{ color: "black" }}>
                Answers to questions about order tracking, return, refund and
                payment
              </p>
            </div>
          </div>
          <span className="arrow">›</span>
        </div>
      </div>

      <div className="right-section">
        <h2 className="login-promo-title">
          Limited time offer: <br />
          Register now and get <strong>7% off</strong> on your first order!
        </h2>
        <button className="btn btn-primary btn-lg" onClick={() => setOpen(true)}>
          Log In / Sign Up
        </button>
      </div>
      <LoginPopup isOpen={open} onClose={() => setOpen(false)} />
    </div>
  );
};

export default LoginProfile;
